$(document).ready(function() {
  function parseVenueZoneMap() {
    var $variantTable = $('#variant-table');
    var zones = $variantTable.data('venue-zones') || [];
    var zoneMap = {};

    $.each(zones, function(_, zone) {
      zoneMap[zone.id] = zone;
    });

    return zoneMap;
  }

  function applyZoneQuantity($select, zoneMap) {
    var zoneId = parseInt($select.val());
    if (!zoneId || !zoneMap[zoneId]) return;

    var quantity = zoneMap[zoneId].quantity || 0;
    var $row = $select.closest('tr');
    var $quantityInput = $row.find('input[name*="[inventory_stock_attributes][quantity]"]');
    $quantityInput.val(quantity);
  }

  function toggleAutomaticSeatingColumns(isAutomatic) {
    $('.automatic-seating-column').toggleClass('d-none', !isAutomatic);
    $('.manual-stock-column').toggleClass('d-none', isAutomatic);

    $('.limit-buy-ticket-input, .venue-zone-select').each(function() {
      $(this).prop('disabled', !isAutomatic);
      $(this).prop('required', isAutomatic);
    });

    $('.quantity-input').each(function() {
      var editLocked = $(this).data('edit-locked') === true || $(this).data('edit-locked') === 'true';
      $(this).prop('disabled', isAutomatic || editLocked);
    });
  }

  var venueZoneMap = parseVenueZoneMap();
  var initialAutomaticSeating = $('#variant-table').data('automatic-seating') === true || $('#variant-table').data('automatic-seating') === 'true';
  toggleAutomaticSeatingColumns(initialAutomaticSeating);

  $(document).on('change', '.venue-zone-select', function() {
    applyZoneQuantity($(this), venueZoneMap);
  });

  $('.venue-zone-select').each(function() {
    applyZoneQuantity($(this), venueZoneMap);
  });

  $('.inventory-category').on('change', function() {
    $('.inventory-category-options').addClass('d-none');
    $('.inventory-category-options select#inventory_event_id').removeAttr('required');

    var inventory_category_id = $(this).val();
    var selectedOption = $(this).find('option:selected');
    var categoryType   = selectedOption.data('category-type');

    // Show/hide Bundle Package? based on category type
    if (categoryType === 'ticket') {
      $('#bundle-package-row').removeClass('d-none');
    } else {
      $('#bundle-package-row').addClass('d-none');
      $('#checkbox-package-product').prop('checked', false).trigger('change');
    }

    $.ajax({
      type: 'GET',
      url: `/admin/inventories/inventory_category_id/${inventory_category_id}/reload_event_options`,
      dataType: 'JSON',
      success: function (result) {
        $('.select-event-options').html('');
        $('.select-event-options').append('<option value>' + I18n.t('actions.select', { item: I18n.t('global.events') }) + '</option>');
        $('#set-variant-button').removeClass('d-none');
        if (result.events.length > 0) {
          $.each(result.events, function(id, elm) {
            $('.select-event-options').append('<option value="'+ elm.id +'">'+ elm.name +'</option>');
          })

          $('.inventory-category-options').removeClass('d-none');

          var $eventLabel = $('.inventory-category-options label[for="inventory_event_id"]');
          var $asterisk = $eventLabel.find('.text-danger');

          if (result.event_required == 'true') {
            $('.inventory-category-options select#inventory_event_id').attr('required', true);
            $('#set-variant-button').addClass('d-none');
            // Add asterisk if not already present
            if ($asterisk.length === 0) {
              $eventLabel.append(' <span class="text-danger">*</span>');
            }
          } else {
            $('.inventory-category-options select#inventory_event_id').removeAttr('required');
            // Remove asterisk if present
            $asterisk.remove();
          }

          $('.select-event-options').select2();
        }
      },
      error: function (xhr, ajaxOptions, thrownError) {
        alert(I18n.t('global.alerts.something_went_wrong'));
      }
    })
  })

  // Function to fix invalid package item values
  function fixPackageItemValues() {
    $('.input-package-item[type="number"]').each(function() {
      var $field = $(this);
      var minVal = parseInt($field.attr('min')) || 1;
      var currentVal = parseInt($field.val()) || 0;
      if (currentVal < minVal) {
        $field.val(minVal);
      }
    });
  }

  $('#checkbox-package-product').change(function(){
    if ($(this).is(":checked")) {
      $('#wrapper-select-package-items').removeClass('hide');
      $('.input-package-item').attr('required', true);
      // Restore min attribute if it was removed
      $('.input-package-item[type="number"]').each(function() {
        var $field = $(this);
        if (!$field.attr('min') && $field.data('original-min')) {
          $field.attr('min', $field.data('original-min'));
        }
      });
      fixPackageItemValues();
    } else {
      $('#wrapper-select-package-items').addClass('hide');
      $('.input-package-item').attr('required', false);
      // Remove min attribute to prevent validation errors on hidden fields
      $('.input-package-item[type="number"]').each(function() {
        var $field = $(this);
        if ($field.attr('min')) {
          $field.data('original-min', $field.attr('min'));
          $field.removeAttr('min');
        }
      });
      // Also ensure values are valid before hiding
      fixPackageItemValues();
    }
  });

  // Fix values on page load if wrapper is hidden
  if ($('#wrapper-select-package-items').hasClass('hide')) {
    $('.input-package-item[type="number"]').each(function() {
      var $field = $(this);
      if ($field.attr('min')) {
        $field.data('original-min', $field.attr('min'));
        $field.removeAttr('min');
      }
    });
  } else {
    fixPackageItemValues();
  }

  // Update productable_type when package item selection changes
  $(document).on('change', '.package-item-select', function() {
    var fieldIdx = $(this).data('field-idx');
    var selectedOption = $(this).find('option:selected');
    var productableType = selectedOption.data('productable-type') || 'Inventory';
    $('.productable-type-field-' + fieldIdx).val(productableType);
  });

  // Initialize productable_type for existing selects on page load
  $('.package-item-select').each(function() {
    var fieldIdx = $(this).data('field-idx');
    var selectedOption = $(this).find('option:selected');
    if (selectedOption.length > 0 && selectedOption.val() !== '') {
      var productableType = selectedOption.data('productable-type') || 'Inventory';
      $('.productable-type-field-' + fieldIdx).val(productableType);
    }
  });

  // Initialize select2 for event select on page load (for edit pages where category is already selected)
  var $eventSelect = $('.select-event-options');
  var $eventContainer = $('.inventory-category-options');
  // Check if select2 is not already initialized (select2 wraps the select in a container)
  var isSelect2Initialized = $eventSelect.next('.select2-container').length > 0 || $eventSelect.data('select2-id');
  if ($eventSelect.length > 0 && !$eventContainer.hasClass('d-none') && !isSelect2Initialized) {
    $eventSelect.select2({
      width: 'resolve'
    });
  }

  $eventSelect.on('change', function() {
    var eventId = $(this).val();
    if (!eventId) return;

    $.ajax({
      type: 'GET',
      url: '/admin/inventories/event_id/' + eventId + '/reload_event_seating_options',
      dataType: 'JSON',
      success: function(result) {
        $('#variant-table').data('automatic-seating', result.automatic_seating_assignment === true);
        $('#variant-table').data('venue-zones', result.venue_zones || []);
        toggleAutomaticSeatingColumns(result.automatic_seating_assignment === true);

        venueZoneMap = {};
        $.each(result.venue_zones || [], function(_, zone) {
          venueZoneMap[zone.id] = zone;
        });

        $('.venue-zone-select').each(function() {
          var $select = $(this);
          var currentValue = $select.val();

          $select.html('');
          $select.append('<option value="">Select Venue Zone</option>');
          $.each(result.venue_zones || [], function(_, zone) {
            $select.append('<option value="' + zone.id + '">' + zone.zone + ' (' + zone.quantity + ' seats)</option>');
          });

          if (currentValue) {
            $select.val(currentValue);
          }

          applyZoneQuantity($select, venueZoneMap);
        });
      }
    });
  });

  // Handle when fields are added via add_fields link (for package items)
  $(document).on('click', '.add_fields', function() {
    // Check if this is adding package item fields
    if ($(this).closest('#wrapper-select-package-items').length > 0 ||
        $(this).data('id') && $('#wrapper-select-package-items').length > 0) {
      setTimeout(function() {
        if ($('#wrapper-select-package-items').hasClass('hide')) {
          // Remove min attribute from new fields if wrapper is hidden
          $('.input-package-item[type="number"]').each(function() {
            var $field = $(this);
            if ($field.attr('min') && !$field.data('original-min')) {
              $field.data('original-min', $field.attr('min'));
              $field.removeAttr('min');
            }
          });
        } else {
          // Ensure new fields have valid values
          fixPackageItemValues();
        }
      }, 100);
    }
  });
})
